"use strict";
function Zoomer(initialZoomLevel) {
  return {
    zoomLevel: initialZoomLevel || 1,
    zoomIn: function() {
      if (this.canZoomIn()) {
        this.zoomLevel += 0.3;
      }
    },
    zoomOut: function() {
      if (this.canZoomOut()) {
        this.zoomLevel -= 0.3;
      }
    },
    canZoomOut: function() {
      return this.zoomLevel > 1;
    },
    canZoomIn: function() {
      return this.zoomLevel < 3;
    }
  };
}
export default Zoomer;
